import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { WwwDirectusService, ToolKitType } from 'www-cms';

export const toolkitContentResolver: ResolveFn<any> = (route, state) => {
  const path = route.url[0]?.path ?? '';
  let type: ToolKitType = 'media';
  if (path === 'partner-toolkit') {
    type = 'reseller';
  }
  return inject(WwwDirectusService).getToolkitContent(type);
};
